/**
 * Theme-owned Back in Stock modal. Opens on .ozlo-bis-trigger /
 * .klaviyo-bis-trigger clicks and posts to Klaviyo's Client API.
 */
(function () {
  var REVISION = '2024-06-15';
  var TRIGGER = '.ozlo-bis-trigger, .klaviyo-bis-trigger';
  var modal = document.getElementById('ozlo-bis-modal');
  if (!modal) return;

  if (modal.parentNode !== document.body) {
    document.body.appendChild(modal);
  }

  var form = modal.querySelector('.ozlo-bis__form');
  var emailInput = document.getElementById('ozlo-bis-email');
  var statusEl = modal.querySelector('.ozlo-bis__status');
  var submitBtn = modal.querySelector('.ozlo-bis__submit');
  var lastFocus = null;
  var variantId = '';
  var supportsDialog = typeof modal.showModal === 'function';

  function getCompanyId() {
    var fromSetting = (modal.getAttribute('data-company-id') || '').trim();
    if (fromSetting) return fromSetting;

    var scripts = document.querySelectorAll('script[src*="klaviyo"]');
    for (var i = 0; i < scripts.length; i++) {
      try {
        var url = new URL(scripts[i].src, window.location.origin);
        var q = url.searchParams.get('company_id');
        if (q) return q;
        var match = url.pathname.match(/\/onsite\/js\/([^/]+)\//);
        if (match) return match[1];
      } catch (e) {
        /* ignore malformed src */
      }
    }
    return '';
  }

  function setStatus(message) {
    if (!statusEl) return;
    if (!message) {
      statusEl.hidden = true;
      statusEl.textContent = '';
      return;
    }
    statusEl.hidden = false;
    statusEl.textContent = message;
  }

  function isOpen() {
    return supportsDialog ? modal.open : modal.classList.contains('is-open');
  }

  function openModal(trigger) {
    if (!trigger) return;
    variantId = (trigger.getAttribute('data-variant-id') || '').trim();
    lastFocus = document.activeElement;
    modal.classList.remove('is-loading', 'is-success');
    if (form) form.hidden = false;
    var success = modal.querySelector('.ozlo-bis__success');
    if (success) success.hidden = true;
    setStatus('');

    if (supportsDialog) {
      if (!modal.open) modal.showModal();
    } else {
      modal.removeAttribute('hidden');
      modal.classList.add('is-open');
    }

    document.body.classList.add('ozlo-bis-open');
    if (emailInput) {
      emailInput.value = emailInput.value || '';
      try {
        emailInput.focus();
      } catch (e) {
        /* ignore */
      }
    }
  }

  function closeModal() {
    if (supportsDialog) {
      if (modal.open) modal.close();
    } else {
      modal.setAttribute('hidden', '');
      modal.classList.remove('is-open');
    }
    modal.classList.remove('is-loading', 'is-success');
    document.body.classList.remove('ozlo-bis-open');
    variantId = '';
    if (lastFocus && typeof lastFocus.focus === 'function') {
      try {
        lastFocus.focus();
      } catch (e) {
        /* ignore */
      }
    }
  }

  function showSuccess() {
    modal.classList.remove('is-loading');
    modal.classList.add('is-success');
    var success = modal.querySelector('.ozlo-bis__success');
    if (success) success.hidden = false;
    if (form) form.hidden = true;
    setStatus('');
    var closeBtn = modal.querySelector('.ozlo-bis__success [data-ozlo-bis-close]');
    if (closeBtn) closeBtn.focus();
  }

  function findTrigger(event) {
    var path = event.composedPath ? event.composedPath() : [];
    for (var i = 0; i < path.length; i++) {
      var node = path[i];
      if (node && node.classList && (node.classList.contains('ozlo-bis-trigger') || node.classList.contains('klaviyo-bis-trigger'))) {
        return node;
      }
    }
    var target = event.target;
    if (target && target.closest) return target.closest(TRIGGER);
    return null;
  }

  function onTriggerClick(event) {
    var trigger = findTrigger(event);
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    openModal(trigger);
  }

  function subscribe(email) {
    var companyId = getCompanyId();
    if (!companyId) {
      setStatus(modal.getAttribute('data-error'));
      return Promise.resolve(false);
    }
    if (!variantId) {
      setStatus(modal.getAttribute('data-error'));
      return Promise.resolve(false);
    }

    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email }
            }
          },
          channels: ['EMAIL']
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: '$shopify:::$default:::' + variantId
            }
          }
        }
      }
    };

    return fetch(
      'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(companyId),
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: REVISION
        },
        body: JSON.stringify(payload)
      }
    ).then(function (res) {
      if (res.status === 202 || res.status === 204 || res.ok) return true;
      return res.json().catch(function () { return {}; }).then(function (body) {
        var detail = body && body.errors && body.errors[0] && body.errors[0].detail;
        throw new Error(detail || modal.getAttribute('data-error'));
      });
    });
  }

  window.ozloOpenBis = openModal;

  document.addEventListener('click', onTriggerClick, true);

  modal.addEventListener('click', function (event) {
    if (event.target === modal || event.target.closest('[data-ozlo-bis-close]')) {
      event.preventDefault();
      closeModal();
    }
  });

  modal.addEventListener('cancel', function (event) {
    event.preventDefault();
    closeModal();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && isOpen()) closeModal();
  });

  if (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var email = (emailInput && emailInput.value ? emailInput.value : '').trim();
      if (!email || (emailInput && !emailInput.checkValidity())) {
        setStatus(modal.getAttribute('data-invalid-email'));
        if (emailInput) emailInput.focus();
        return;
      }

      modal.classList.add('is-loading');
      if (submitBtn) submitBtn.disabled = true;
      setStatus('');

      subscribe(email)
        .then(function (ok) {
          if (submitBtn) submitBtn.disabled = false;
          if (ok) showSuccess();
          else modal.classList.remove('is-loading');
        })
        .catch(function (err) {
          modal.classList.remove('is-loading');
          if (submitBtn) submitBtn.disabled = false;
          setStatus((err && err.message) || modal.getAttribute('data-error'));
        });
    });
  }

  if (window.__ozloBisQueue) {
    openModal(window.__ozloBisQueue);
    window.__ozloBisQueue = null;
  }
})();
